import React from 'react'

export default {
  type: 'autoselect',
  LazyComponent: React.lazy(() => import('./autoSelect'))
}
